<template>
  <div class="card rounded-none bg-base-100 md:hidden !shadow-none product-mobile" v-for="(product, index) in products"
    @click="$emit('getProduct', product.slug)" v-if="!grid"
    :class="[$route.meta.tableClass, search && index == 0 ? 'border-animation' : '']">
    <div class="card-body flex-row p-2">
      <div class="relative">
        <img class="rounded-lg w-24 h-24" :src="product.image" alt="product" />
        <label class="btn btn-error btn-xs btn-circle absolute top-0 left-0 m-2" for="delete-modal"
          @click.stop="$emit('setProduct', product.id)" v-if="['reserve'].includes($route.meta.type)">
          <TrashIcon class="w-4 h-4" />
        </label>
      </div>
      <div class="bg-red-custom-2 px-2 rounded-e-sm text-sm text-white absolute top-0 right-0"
        v-if="product.regular_price > product.wholesale_price">{{
          discount(product.regular_price, product.wholesale_price) }}%</div>
      <div class="flex flex-col flex-1 justify-between">
        <h1 class="font-bold text-sm text-gray-custom-3 line-clamp-2">{{ product.title }} <span
            class="text-red-custom-2" v-if="product.group_sale">({{ product.group_sale + ' ' + __('Integer') }})</span>
        </h1>
        <div class="card-actions items-center">
          <div class="flex justify-between items-center w-full">
            <div class="text-xs sm:text-sm">{{ __('Product Code') + ': ' + (product.sku) }}</div>
            <div v-if="product?.payment_method">
              <!-- <span class="text-xs sm:text-sm">{{ __('sale') + ': ' }}</span> -->
              <span class="badge border-0 text-xs sm:text-sm"
                :class="[product.payment_method === 'cash' ? '!bg-red-custom-1 !text-red-custom-2' : ' !bg-green-custom-2 !text-green-custom-3']">
                {{ __(product.payment_method?.capitalize()) + (product.payment_method === 'check' &&
                  product.payment_term ? ' - ' + product.payment_term + ' ' +
                __('Day') : '') }}
              </span>
            </div>
          </div>
          <div class="flex justify-between items-center w-full">
            <ProductQuantity :product="product" @change="change" />
            <div class="flex flex-col items-center">
              <div v-if="$route.meta.type === 'change'">
                <span class="line-through text-xs">{{ product.previous_price.toLocaleString() }}</span>
                <Currency size="small" />
              </div>
              <div>
                <div class="flex flex-col">
                  <span class="text-red-custom-2 font-medium text-sm">
                    <span v-if="$route.meta.type === 'change'" class="ml-0.5">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-caret-up-fill w-3 h-3 text-success inline" viewBox="0 0 16 16"
                        v-if="product.wholesale_price > product.previous_price">
                        <path
                          d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-caret-down-fill w-3 h-3 text-error inline" viewBox="0 0 16 16"
                        v-else-if="product.wholesale_price < product.previous_price">
                        <path
                          d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                      </svg>

                    </span>
                    <span v-if="product.wholesale_price">
                      {{ product.wholesale_price.toLocaleString() }}
                      <Currency />
                    </span>
                    <span v-else class="text-info">{{ __('Price is changing.') }}</span>
                  </span>
                  <span class="text-sm line-through ml-6"
                    v-if="$route.meta.type != 'change' && product.wholesale_price && product.regular_price > product.wholesale_price">{{
                      product.regular_price.toLocaleString() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider my-0 h-auto" v-if="$route.meta.type === 'cart'"></div>
    <div class="flex flex-row justify-between p-2" v-if="$route.meta.type === 'cart'">
      <div v-if="$route.meta.type === 'cart'">
        <span class="text-sm">{{ __('total amount') }}: </span><span class="text-red-custom-2">{{
          (product.wholesale_price *
            product.quantity).toLocaleString() }}</span>
        <Currency />
      </div>
      <label class="btn btn-error btn-xs" for="delete-modal" @click="$emit('setProduct', product.id)">
        <XMarkIcon class="w-5 h-5" />
      </label>
    </div>
  </div>
  <div class="hidden md:block" v-if="!grid">
    <table class="table w-full table-compact 2xl:table-normal">
      <thead :class="{ 'md:!sticky': $route.meta.type !== 'cart' }">
        <tr>
          <th>{{ __('Product Code') }}</th>
          <!-- <th>{{ __('brand') }}</th> -->
          <th class="!text-start">{{ __('the product') }}</th>
          <th v-if="meta?.check_condition">{{ __('sale') }}</th>
          <th v-if="$route.meta.type === 'change'">{{ __('Previous price') }}</th>
          <th>{{ __($route.meta.type === 'change' ? 'New price' : 'Price') }}</th>
          <th>{{ __('Quantity') }}</th>
          <th v-if="['cart', 'reserve'].includes($route.meta.type)">{{ __('total amount') }}</th>
          <th v-if="$route.meta.type !== 'cart'">{{ __('the show') }}</th>
          <th v-if="['cart', 'reserve'].includes($route.meta.type)">{{ __('Delete') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(product, index) in products" v-show="!activeTab || product.stock_status === activeTab"
          :class="[$route.meta.tableClass, search && index == 0 ? 'border-animation' : '']">
          <td class="text-gray-custom-1 text-center">{{ product.sku }}</td>
          <!-- <td class="text-gray-custom-1 text-center">{{product.brand || '---'}}</td> -->
          <td class="text-gray-custom-3 text-start align-top">
            <div class="flex items-center gap-3 w-full overflow-hidden">
              <img class="rounded-sm w-16 h-16 flex-shrink-0" :src="product.image" alt="product" />
              <div class="flex-1 text-start whitespace-normal break-words min-w-0">
                {{ product.title }}
                <span class="text-red-custom-2" v-if="product.group_sale">
                  ({{ product.group_sale + ' ' + __('Integer') }})
                </span>
              </div>
            </div>
          </td>


          <td class="text-center" v-if="product?.payment_method">
            <div class="badge border-0 rounded-sm"
              :class="[product.payment_method === 'cash' ? '!bg-red-custom-1 !text-red-custom-2' : ' !bg-green-custom-2 !text-green-custom-3']">
              {{ __(product.payment_method?.capitalize()) + (product.payment_method === 'check' && product.payment_term
                ? ' - ' + product.payment_term + ' ' +
                __('Day') : '') }}
            </div>
          </td>
          <td class="text-center" v-if="$route.meta.type === 'change'">
            <span class="text-green-custom-3">{{ product.previous_price.toLocaleString() }}</span>
            <Currency />
          </td>
          <td class="text-center">
            <div class="flex flex-col">
              <span>
                <span v-if="$route.meta.type === 'change' && product.wholesale_price" class="ml-0.5 text-red-custom-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-caret-up-fill w-4 h-4 text-success inline" viewBox="0 0 16 16"
                    v-if="product.wholesale_price && product.wholesale_price > product.previous_price">
                    <path
                      d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-caret-down-fill w-4 h-4 text-error inline" viewBox="0 0 16 16"
                    v-else-if="product.wholesale_price < product.previous_price">
                    <path
                      d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </span>
                <span v-if="product.wholesale_price">
                  <!-- <PriceChangeDropdown :price="product.wholesale_price" :old_price="product.previous_price" /> -->
                  <span class="text-red-custom-2">
                    {{ product.wholesale_price.toLocaleString() }}
                    <Currency class="!mr-0" />
                  </span>
                </span>
                <span v-else class="text-info">{{ __('Price is changing.') }}</span>
              </span>
              <span class="text-sm flex justify-center items-center"
                v-if="$route.meta.type != 'change' && product.wholesale_price && product.regular_price > product.wholesale_price">
                <span class="line-through">{{ product.regular_price.toLocaleString() }}</span>
                <span class="bg-red-custom-2 px-2 py-[1px] mr-1 mt-0.5 rounded-md text-xs text-white"
                  v-if="product.regular_price > product.wholesale_price">{{
                    discount(product.regular_price, product.wholesale_price) }}%</span>
              </span>
            </div>
          </td>

          <td class="text-center">
            <ProductQuantity :product="product" @change="change" />
          </td>
          <td class="text-center" v-if="['cart', 'reserve'].includes($route.meta.type)">
            <span class="text-red-custom-2">{{ (product.wholesale_price *
              product.quantity).toLocaleString() }}</span>
            <Currency />
          </td>
          <td class="text-center" v-if="$route.meta.type !== 'cart'">
            <label class="btn btn-success btn-xs 2xl:btn-sm" @click="$emit('getProduct', product.slug)">
              <EyeIcon class="w-5 h-5" />
            </label>
          </td>
          <td class="text-center" v-if="['cart', 'reserve'].includes($route.meta.type)">
            <label class="btn btn-error btn-xs 2xl:btn-sm" for="delete-modal" @click="$emit('setProduct', product.id)">
              <XMarkIcon class="w-5 h-5" />
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup>
import {
  EyeIcon,
  XMarkIcon,
  ChartBarIcon,
} from '@heroicons/vue/24/outline'
import PriceChangeDropdown from '../layout/PriceChangeDropdown.vue';
import ProductQuantity from './ProductQuantity.vue';
import Currency from '../../svg/Currency.vue';
import { discount } from '@/util.js';
import { TrashIcon } from '@heroicons/vue/24/solid';
const emit = defineEmits(['getProduct', 'changeQuantity', 'setProduct']);
defineProps(['products', 'grid', 'loading', 'activeTab', 'search', 'meta']);
const change = (product, quantity) => emit('changeQuantity', product, quantity);

</script>